import { connectMediaStore } from './withOwnReduxStore';
import { getAllowedDeviationTypes, getAllowedDeviationResourceTypes, getAllowGifs, getAllowPremium, getAllowMature, getIgnoreDeviationIds, getMinDeviationWidth, getMinDeviationHeight, getAllowInTierContent } from '../selectors';
export default connectMediaStore((state)=>({
        allowedDeviationTypes: getAllowedDeviationTypes(state),
        allowedDeviationResourceTypes: getAllowedDeviationResourceTypes(state),
        allowGifs: getAllowGifs(state),
        allowPremium: getAllowPremium(state),
        allowInTierContent: getAllowInTierContent(state),
        allowMature: getAllowMature(state),
        ignoreDeviationIds: getIgnoreDeviationIds(state),
        minDeviationWidth: getMinDeviationWidth(state),
        minDeviationHeight: getMinDeviationHeight(state)
    }));
